export default __webpack_public_path__ + "static/media/three-dot.cf70df60.svg";